<template>
        <div class="eta-container">
            <div class="img-container">
                <div class="default-img-container pb-1">
                    <img  
                        src="https://assets.friendlydiamonds.com/fdl/fd_gif/shipment.gif" 
                        width="35" height="35" 
                        alt="estimate shipment">
                </div>
            </div>
            <div class="content-container">
                <p class="delivery-text">
                    <span>{{ $country.estimate_msg }}&nbsp;</span>
                    <span class="date">{{ etaData?.data?.eta ? etaData.data.eta: 'NA' }}</span>
                </p>
            </div>
        </div>
</template>

<script setup>

    // ALWYAS Y+USE IN BELOW MANNER
    // reactivity will be intact -> module_subtype   

    const props  = defineProps(['module_subtype', 'setting_id','diamond_id', 'size'])
    const { module_subtype, setting_id, diamond_id, size } = toRefs(props)
    const status = ref('pending'); 
    // Watchers for setting_id and size
    
    const type = ref('')

    const etaData = ref(null)
   
    
    if(['ring', 'loose'].includes(module_subtype.value)){

        type.value = 'cyor'
    }
    else if(module_subtype.value == 'pendant'){

        type.value = 'cyop'
    }
    else if(module_subtype.value == 'earring'){

        type.value = 'cyoe'
    }
    else if(module_subtype.value == 'preset'){

        type.value = 'preset'
    }
    else{
        type.value = 'shop'
    }

    
    const isSale = computed(()=>{
        return etaData.value?.data?.before_christmas || etaData.value?.data?.before_new_year 
    })

    onMounted(() => {

        watchEffect(() => {
            
            status.value = 'pending';
            
            const url = useCountryPath(`/setting/${type.value}/eta?sid=${setting_id.value}&did=${diamond_id.value}&size=${size.value}`)
            try {
                $fetch(url).then( (res) => {
                    if (res?.data?.eta) {
                        etaData.value = res;
                        status.value = 'success';  
    
                    }
                });
            } catch (error) {
                console.error('Error fetching ETA data:', error);
                status.value = 'error';

            }
        })
    });

</script>

<style scoped>
/* remove default margin */
p{
    margin: 0;
}

.eta-container{
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 10px 12px;
    gap: 12px;
}


.delivery-text, 
.sale-content p{
    font-size: 16px;
    font-weight: 600;
}

.delivery-text .date{
    color: var(--green);
}

.sale-eta-container{
    padding: 0;
}

.sale-eta-container 
.content-container{
    padding: 8px 12px 8px 0px;
}

.sale-content p{
    color: #405955;
}


@media(max-width:991px){

    .delivery-text, 
    .sale-content p{
        font-size: 14px;
    }

}

</style>